import React, { SetStateAction, useEffect, useState } from 'react';
import {
    Box, Typography, Divider, Select, MenuItem, FormControl, InputLabel, Button, Chip,
    Slider, Checkbox, ListItemText, Table, TableBody, TextField, Autocomplete, Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem,
    TableCell, TableContainer, TableHead, TableRow, IconButton, ListSubheader, InputAdornment, FormGroup, Tooltip, Accordion, AccordionSummary, AccordionDetails, Switch, 
} from '@mui/material';
import MuiAccordionSummary, {
    AccordionSummaryProps,
  } from '@mui/material/AccordionSummary';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ClearIcon from '@mui/icons-material/Clear';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import SearchableDropdown from "../components/SearchableDropdown";
import AddIcon from '@mui/icons-material/Add';
import { display, styled } from '@mui/system';
import { Search } from 'react-router-dom';
import { arrayFields } from 'geotiff/dist-node/globals';
import { Check, ExpandMore, NoMeetingRoomSharp } from '@mui/icons-material';
import RelativeStepControls from './RelativeStepControls';
import { norm } from 'mathjs';
import { set } from 'lodash';

type DataProcessingStepProps = {
    groupBy: string [] | undefined;
    setGroupBy: React.Dispatch<React.SetStateAction<SearchableDropdownOption[]>>;
    groupbyOptions: SearchableDropdownOption [];
    aggregationMethod: string | undefined;
    setAggregationMethod: React.Dispatch<React.SetStateAction<string>>;
    normalizeBy: SearchableDropdownOption[];
    normByOptions: SearchableDropdownOption[];
    setNormalizeBy: React.Dispatch<React.SetStateAction<SearchableDropdownOption[]>>;
    normalizeUnits: string;
    setNormalizeUnits: React.Dispatch<React.SetStateAction<string>>;
    references: Reference[];
    normReferences: Reference[];
    referenceColumnOptions: SearchableDropdownOption[];
    setReferences: React.Dispatch<React.SetStateAction<Reference[]>>;
    setNormReferences: React.Dispatch<React.SetStateAction<Reference[]>>;
    referenceValueOptions: {[vt: string]: SearchableDropdownOption[]}; //SearchableDropdownOption[];
    relativeUnits: string;
    setRelativeUnits: React.Dispatch<React.SetStateAction<string>>;
    normRelativeUnits: string;
    setNormRelativeUnits: React.Dispatch<React.SetStateAction<string>>;
    processingMode: 'absolute' | 'relative' | undefined;
    setProcessingMode: React.Dispatch<React.SetStateAction<'absolute' | 'relative'>>;
    hideReference: boolean;
    setHideReference: React.Dispatch<React.SetStateAction<boolean>>;
    normHideReference: boolean;
    setNormHideReference: React.Dispatch<React.SetStateAction<boolean>>;
    groupByRelative: string [];
    setGroupByRelative: React.Dispatch<React.SetStateAction<SearchableDropdownOption[]>>;
    groupByNormRelative: string [];
    setGroupByNormRelative: React.Dispatch<React.SetStateAction<SearchableDropdownOption[]>>;
    showPathwayMode: boolean;
    pathwayMode: boolean;
    setPathwayMode: React.Dispatch<React.SetStateAction<boolean>>;
    pathwayScore: string;
    setPathwayScore: React.Dispatch<React.SetStateAction<string>>;
    error: string;
    setError: React.Dispatch<React.SetStateAction<string>>;
};

const CustomAccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
      {...props}
    />
  ))(({ theme }) => ({
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, .05)'
        : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-content': {
      marginLeft: theme.spacing(1),
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
        transform: 'rotate(-90deg)',
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(0deg)',
    },
}));

const DataProcessingStep: React.FC<DataProcessingStepProps> = ({
    groupBy,
    setGroupBy,
    groupbyOptions,
    aggregationMethod,
    setAggregationMethod,
    normalizeBy,
    normByOptions,
    setNormalizeBy,
    normalizeUnits,
    setNormalizeUnits,
    references,
    normReferences,
    referenceColumnOptions,
    setReferences,
    setNormReferences,
    referenceValueOptions,
    relativeUnits,
    setRelativeUnits,
    normRelativeUnits,
    setNormRelativeUnits,
    processingMode,
    setProcessingMode,
    hideReference,
    setHideReference,
    normHideReference,
    setNormHideReference,
    groupByRelative,
    setGroupByRelative,
    groupByNormRelative,
    setGroupByNormRelative,
    showPathwayMode,
    pathwayMode,
    setPathwayMode,
    pathwayScore,
    setPathwayScore,
    error,
    setError,
}) => {

    const [normalizeExpand, setNormalizeExpand] = useState<boolean>(false);
    const [groupByExpand, setGroupByExpand] = useState<boolean>(false);
    const [reduceExpand, setReduceExpand] = useState<boolean>(false);
    const [viewExpand, setViewExpand] = useState<boolean>(false);
    const [normalizeByColumn, setNormalizeByColumn] = useState<boolean>(false);


    useEffect(() => {
        if (pathwayScore == 'ges' && processingMode == 'absolute') {
            setError("Gene Embedding Score can only be used in relative mode.");
        } else {
            setError("");
        }
    }, [pathwayScore, processingMode]);

    return (<div>
        {/* <ListItem style={{ width: '100%' }}>
            <FormControl fullWidth>
                <InputLabel id="groupby-method-label">Group By</InputLabel>
                <Select
                    labelId="groupby-method-label"
                    id="groupby-method-select"
                    value={groupBy ? (groupBy[0] ? groupBy[0] : "") : ""}
                    onChange={(event) => {
                        if (event.target.value === "") {
                        setGroupBy([]);
                        } else {
                        setGroupBy([{ label: event.target.value, value: event.target.value }]);
                        }
                    }}
                    label="Select Group By"
                    endAdornment={
                        groupBy && groupBy[0] && (
                        <InputAdornment position="end">
                            <IconButton
                            onClick={() => setGroupBy([])}
                            onMouseDown={(event) => event.preventDefault()}
                            edge="end"
                            size="small"
                            style={{ marginRight: 8 }}
                            >
                            <ClearIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                        )
                    }
                    style={{ paddingRight: groupBy && groupBy[0] ? 32 : 8 }}
                    >
                    <MenuItem value="Sample Title">Sample Title</MenuItem>
                    <MenuItem value="Treatment_and_Dose">Treatment and Dose</MenuItem>
                    <MenuItem value="Timepoint">Timepoint</MenuItem>
                    <MenuItem value="channel_id">Channel ID</MenuItem>
                    </Select>
            </FormControl>
        </ListItem> */}
        
       
        {/* <ListItem>
            <FormGroup>
                <FormControlLabel 
                control={
                    <Checkbox
                        checked={normalize}
                        aria-labelledby='should-normalize-label'
                        onChange={(event) => setNormalize(event.target.checked)}
                    />
                }
                label="Normalize"
                />
            </FormGroup>
        </ListItem> */}
        <Accordion
            key={"norm"}
            elevation={0}
            expanded={normalizeExpand}
            onChange={() => {
                setNormalizeExpand(!normalizeExpand) 
            }}
            sx={{
                border: '1px solid lightgray',
                // borderBottom: 0,
                '&:before': { display: 'none' },
                margin: 0,
            }}
        >   
            <CustomAccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls={`panel-norm-content`}
                id={`panel-norm-header`}
                sx={{ 
                    minHeight:'30px',
                    '& .MuiAccordionSummary-root.Mui-expanded': {
                        minHeight:'30px',
                        margin: '0px'
                    },
                    '& .MuiAccordionSummary-content.Mui-expanded': {
                        minHeight:'30px',
                        margin:'0px'
                    }
                }}
            >
                <Box display={'flex'} flexDirection={'row'} width={'100%'}>
                    <Typography variant="subtitle1" sx={{ flexGrow: 1 }} width={'50%'}>
                        <b>Normalize</b>
                    </Typography>
                    <Typography variant="subtitle1" sx={{ flexGrow: 1, align:'right', textAlign:'right', color:'rgba(0, 0, 0, 0.6)'}} width={'50%'}>
                        <i>Optional</i>
                    </Typography>
                </Box>
            </CustomAccordionSummary >
            <AccordionDetails >
                {/* <Box sx={{ width: '100%', p: 1}}>
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="normalize-mode-label"
                            name="normalize-mode-radio-buttons-group"
                            value={normalizeByColumn ? 'column' : 'reference'}
                            onChange={(event)=>{setNormalizeByColumn(event.target.value as any === 'column')}}
                        >
                            <FormControlLabel value="column" control={<Radio />} label="By Column" />
                            <FormControlLabel value="reference" control={<Radio />} label="By Reference" />
                        </RadioGroup>
                    </FormControl>
                </Box> */}
                {(normalizeByColumn) ?
                    <>
                        <Box sx={{width:'100%', p:1}}>
                                <SearchableDropdown
                                    fullWidth
                                    label="Column To Normalize by"
                                    value={normalizeBy}
                                    multiple={false}
                                    setValue={setNormalizeBy}
                                    options={normByOptions}
                                    forcePill={true}
                                    placeholder="Normalize By"
                                />
                        </Box>
                        <Box sx={{width:'100%', p:1}}>
                                <FormControl fullWidth>
                                    <InputLabel id="units-label">Units</InputLabel>
                                    <Select
                                    labelId="units-label"
                                    id="units-select"
                                    value={normalizeUnits}
                                    label="Units"
                                    disabled={!normalizeBy.length}
                                    onChange={(event) => { setNormalizeUnits(event.target.value as any)}}
                                    >
                                    <MenuItem value="fold_change">Fold Change</MenuItem>
                                    <MenuItem value="log2_fold_change">log2(Fold Change)</MenuItem>
                                    <MenuItem value="log2_fold_change_smooth">log2(Fold Change) smooth</MenuItem>
                                    <MenuItem value="percentage">%</MenuItem>
                                    </Select>
                                </FormControl>
                        </Box>
                    </>
                :
                <RelativeStepControls
                    references={normReferences}
                    setReferences={setNormReferences}
                    referenceColumnOptions={referenceColumnOptions}
                    referenceValueOptions={referenceValueOptions}
                    relativeUnits={normRelativeUnits}
                    setRelativeUnits={setNormRelativeUnits}
                    hideReference={normHideReference}
                    setHideReference={setNormHideReference}
                    groupByRelative={groupByNormRelative}
                    setGroupByRelative={setGroupByNormRelative}
                    groupBy={groupBy}
                    groupbyOptions={groupbyOptions}
                    hideOptions={true}
                />}
            </AccordionDetails>
        </Accordion>
        <Accordion
            key={"group"}
            elevation={0}
            expanded={groupByExpand}
            onChange={() => {
                setGroupByExpand(!groupByExpand)
            }}
            sx={{
                border: '1px solid lightgray',
                // borderBottom: 0,
                '&:before': { display: 'none' },
                margin: 0,
            }}
        >   
            <CustomAccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls={`panel-group-content`}
                id={`panel-group-header`}
                // sx={{
                //     minHeight:'30px',
                //     '& .MuiAccordionSummary-root.Mui-expanded': {
                //         minHeight:'30px',
                //         margin: '0px'
                //     },
                //     '& .MuiAccordionSummary-content.Mui-expanded': {
                //         minHeight:'30px',
                //         margin:'0px'
                //     }
                // }}
            >
                <Box display={'flex'} flexDirection={'row'} width={'100%'}>
                    <Typography variant="subtitle1" sx={{ flexGrow: 1 }} width={'50%'}>
                        <b>Group</b>
                    </Typography>
                    <Typography variant="subtitle1" sx={{ flexGrow: 1, align:'right', textAlign:'right', color:'rgba(0, 0, 0, 0.6)'}} width={'50%'}>
                        <i>Optional</i>
                    </Typography>
                </Box>
            </CustomAccordionSummary>
            <AccordionDetails >
                <Box style={{ width: '100%' }} sx={{p:1}}>
                    <SearchableDropdown
                        fullWidth
                        label="Select Group By"
                        value={groupBy ? groupBy.map(item => ({label: item.replace('|', ' '), value: item})) : []}
                        setValue={setGroupBy}
                        options={groupbyOptions}
                        // disabled={pathwayMode}
                        placeholder="Group By"
                    />
                </Box>
                <Box style={{ width: '100%'}} sx={{p:1}}>
                    <FormControl fullWidth>
                        <InputLabel id="aggregation-method-label">Aggregation Method</InputLabel>
                        <Select
                        labelId="aggregation-method-label"
                        id="aggregation-method-select"
                        value={aggregationMethod}
                        label="Aggregation Method"
                        onChange={(event) => setAggregationMethod(event.target.value)}
                        // disabled={pathwayMode}
                        >
                        <MenuItem value="mean">Mean</MenuItem>
                        <MenuItem value="median">Median</MenuItem>
                        <MenuItem value="max">Max</MenuItem>
                        <MenuItem value="min">Min</MenuItem>
                        <MenuItem value="sum">Sum</MenuItem>
                        <MenuItem value="count">Count</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                
                {(showPathwayMode) ? 
                    <>
                        <br/>
                        <Box display={'flex'} flexDirection="row">
                            <Tooltip title={((!pathwayMode) ? 'Enable' : 'Disable') +' Pathway Mode'}>
                                <Switch checked={pathwayMode} onChange={() => {setPathwayMode(!pathwayMode); setReduceExpand(!pathwayMode);}}  sx={{ align:'right', textAlign:'right'}} />
                            </Tooltip>
                            <Typography variant="body1" sx={{ flexGrow: 1 }} width={'50%'} mt={1}>
                                <b>Pathway Mode</b>
                            </Typography>
                            
                        </Box>
                    {(pathwayMode) ? <Box style={{ width: '100%'}} sx={{p:1}}>
                        <FormControl fullWidth>
                            <InputLabel id="pathway-score-label">Pathway Score</InputLabel>
                            <Select
                            labelId="pathway-score-label"
                            id="pathway-score-select"
                            value={pathwayScore}
                            label="Pathway Score"
                            disabled={!pathwayMode}
                            onChange={(event) => setPathwayScore(event.target.value)}
                            >
                            <MenuItem value="mean">Mean</MenuItem>
                            <MenuItem value="median">Median</MenuItem>
                            <MenuItem value="geomean">Geometric Mean</MenuItem>
                            <MenuItem value="rms">Root Mean Square</MenuItem>
                            <MenuItem value="max">Max</MenuItem>
                            <MenuItem value="min">Min</MenuItem>
                            <MenuItem value="sum">Sum</MenuItem>
                            <MenuItem value="ges">Gene Embedding Score (GES)</MenuItem>
                            </Select>
                        </FormControl> 
                    </Box> : <></>
                    }</> : <></>
                }
            </AccordionDetails>
        </Accordion>
        <Accordion
            key={"view_mode"}
            elevation={0}
            expanded={viewExpand}
            onChange={() => {
                setViewExpand(!viewExpand)
            }}
            sx={{
                border: '1px solid lightgray',
                // borderBottom: 0,
                '&:before': { display: 'none' },
                margin: 0,
            }}
        >   
            <CustomAccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls={`panel-view_mode-content`}
                id={`panel-view_mode-header`}
                
            >
                <Box display={'flex'} flexDirection={'row'} width={'100%'}>
                    <Typography variant="subtitle1" sx={{ flexGrow: 1 }} width={'50%'}>
                        <b>View</b>
                    </Typography>
                    <Typography variant="subtitle1" sx={{ flexGrow: 1, align:'right', textAlign:'right', color:'rgba(0, 0, 0, 0.6)'}} width={'50%'}>
                        <i>Optional</i>
                    </Typography>
                </Box>
            </CustomAccordionSummary >
                    
            <AccordionDetails>
                    <Box sx={{ width: '100%', p: 1}}>
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="processing-mode-label"
                                name="processing-mode-radio-buttons-group"
                                value={processingMode}
                                onChange={(event)=>{setProcessingMode(event.target.value as any)}}
                            >
                                <FormControlLabel value="absolute" control={<Radio />} label="Absolute" />
                                <FormControlLabel value="relative" control={<Radio />} label="Relative" />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                    { (processingMode == 'relative') ? 
                        <RelativeStepControls
                            references={references}
                            setReferences={setReferences}
                            referenceColumnOptions={referenceColumnOptions}
                            referenceValueOptions={referenceValueOptions}
                            relativeUnits={relativeUnits}
                            setRelativeUnits={setRelativeUnits}
                            hideReference={hideReference}
                            setHideReference={setHideReference}
                            groupByRelative={groupByRelative}
                            setGroupByRelative={setGroupByRelative}
                            groupBy={groupBy}
                            groupbyOptions={groupbyOptions}
                        />
                        :
                        <Box></Box>
                    }
                </AccordionDetails>
        </Accordion>
        <br></br>
        {error ? <Typography color={'red'}>{error}</Typography> : <></>}
        </div>
    );
};

export default DataProcessingStep;


